<template>
  <div class="basic-info-main" :style="iosOrAndroidStyle">

    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="基本信息"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />

    <!-- <cube-button @click="showDefault"> -->
      <item name="头像" :isHeight="true" :rightSlot="true" @click="selectAvatar">
        <template v-slot:rightSlot>
          <img v-if="avatar" :src="avatar || 'https://files.wondercv.com/default_avatar.png'" alt="" class="profile">
          <span v-else>未设置</span>
        </template>
      </item>
    <!-- </cube-button> -->

    <item name="姓名" :value="name" @click.native="routeTo('/account/alter_user_name?name=' + name)"></item>
    <cube-button @click="showPicker">
      <item name="性别" :value="gender"></item>
    </cube-button>
    <item name="社区昵称" :value="username" @click="isFillIdentify()"></item>
    <item name="社群身份" :value="showCommunityIdentify ? community_identify : '已隐藏'" @click="routerTo('/account/alter_user_community_identity')"></item>


    <cube-button @click="showPickerIdentify()">
      <item name="求职身份" :value="identify === 'already_work' ? '职场人' : identify === 'student' ? '学生' : ''"></item>
    </cube-button>

    <input type="file" accept="image/*" ref="basicInfoUpInput" @change="fileChange" class="up-file">

  </div>
</template>
<script>
import { envMixin } from '@/assets/js/mixin/global';
import { userMixin } from '@/assets/js/mixin/user';
import { componentsMixin } from '../../assets/js/mixin/components'
import WNavbar from "@/components/global/w-navbar";
import Item from './components/item';
// import {routerTo} from "@/assets/js/util";

export default {
  name: 'BasicInfo',
  mixins: [ envMixin, userMixin, componentsMixin ],
  components: {
    WNavbar,
    Item
  },
  data() {
    return {
      name: '',
      nickname: '',
      username: '',
      community_identify:'', // 社群身份
      gender: '',
      avatar: '',
      user_username_first: '',
      email: '',
      identify: '', // 用户身份
      showCommunityIdentify: false
    };
  },
  mounted() {
    this.getBasicInfo();
    this.getCommunityInfo()
  },
  watch: {
    identify () {
      this.getCommunityInfo()
    }
  },
  methods: {
    routerTo(url){
      this.$router.push(url)
    },
    // 判断 求职身份是否填写
    isFillIdentify () {
      if (this.identify) {
        this.routerTo('/account/alter_user_username?username=' + this.username);
      } else {
        this.showPickerIdentify()
      }
    },
    // 上传头像
    selectAvatar() {
      this.$refs.basicInfoUpInput.click();
    },
    fileChange(data) {
      let file = this.$refs.basicInfoUpInput.files[0];
      this.$store.dispatch('user/setUpFile', file);
      this.$router.push('/account/alter_user_avatar');
    },
    showDefault() {
      this.$createActionSheet({
        data: [
          {
            content: '拍照',
            class: 'cube-foo'
          },
          {
            content: '从相册中选择',
            class: 'cube-foo'
          }
        ],
        onSelect: (item, index) => {
          console.log(item);
          if (item.content === '拍照') {}
        }
      }).show()
    },
    showPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '性别',
          data: [[{text: '男', value: '男'}, {text: '女', value: '女'}]],
          onSelect: this.selectGender,
          selectedIndex: [this.gender === '男' ? 0 : 1],
          // onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    showPickerIdentify() {
      if (!this.picker1) {
        this.picker1 = this.$createPicker({
          title: '身份',
          data: [[{text: '学生', value: 'student'}, {text: '职场人', value: 'already_work'}]],
          onSelect: this.selectIdentify,
          selectedIndex: [this.identify === 'student' ? 0 : 1],
          // onCancel: this.cancelHandle
        })
      }
      this.picker1.show()
    },
    // 选择性别
    async selectGender(data) {
      this.gender = data[0]
      let res = await this.$api.online.createBasicInfo({gender: this.gender}, this.cvAccountToken);
      if (res.code === 1000) {
        this.showToast('修改成功');
      }
      else {
        this.showToast('修改失败');
      }
    },
    async selectIdentify(data) {
      this.identify = data[0];
      // let res = await this.$api.intention.chooseIdentity({id: this.cvAccountToken, status: data[0]});
      let res = await this.$api.intention.chooseIdentity(this.cvAccountToken,{status: data[0]});
      if (res.code === 1000) {
        this.showToast('修改成功');
      }
      else {
        this.showToast('修改失败');
      }
    },

    leftBtnClick() {
      this.$router.back();
    },

    regEmail() {
      this.routeTo('/emails/my?to_type=create_account');
    },

    async getBasicInfo () {
      let res = await this.$api.online.getCvBasicInfo(this.cvAccountToken);
      this.username = res.data.username;
      this.gender = res.data.gender;
      this.avatar = res.data.avatar;
      this.name = res.data.name

      // res = await this.$api.intention.getIdentity({id: this.cvAccountToken});
      // this.identify = res.data.status;
    },
    async getCommunityInfo () {
      let res = await this.$api.community.getCommunityInfo(this.cvAccountToken)
      this.identify = res.data.status;
      this.showCommunityIdentify = res.data.show_community_identity
      if (this.identify === 'student') {
        this.community_identify = res.data.stu_community_prefix ? res.data.stu_community_prefix + '/' + res.data.stu_community_suffix : ''
      } else if (this.identify === 'already_work') {
        this.community_identify = res.data.com_community_prefix ?  res.data.com_community_prefix + '/' + res.data.com_community_suffix : ''
      } else {
        this.community_identify = ''
      }
      this.community_identify = this.community_identify && this.community_identify.length > 12 ? this.community_identify.substring(0, 13) + '...' : this.community_identify 
    },
  },
}
</script>
<style lang="scss" scoped>
.basic-info-main {
  padding-top: 44px;
  .up-file {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .profile {
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }
  .reg {
    font-size: 14px;
    color: #ff4f4c;
    margin-right: 4px;
  }
}
</style>
<style lang="scss">
  @import "../../assets/scss/global/mixin";
.basic-info-main {
  padding: 0 24px;
  .user-item-main {
    padding: 0;
    border-bottom: 1px solid #EEEFF0;
    &::after {
      display: none;
    }
    .user-item-right {
      display: flex;
      align-items: center;
      padding-right: 0;
      span {
        /*display: inline-block;*/
        @include ellipsis(260px);
      }
    }
  }
  .cube-btn {
    padding: 0!important;
    background: transparent!important;
    color: #404040!important;
    font-size: 14px;
  }
}
</style>
